<!--
 * @Description: 教职工请假记录 添加
 * @Author: PF
 * @Date: 2023-07-17 15:31:01.915
 * @LastEditors: PF
 * @LastEditTime: 2023-07-17 16:55:54
-->
<template>
  <div>
    <el-dialog class="w600 h500" :model-value="openAdd" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon">
            <Edit />
          </el-icon>
          <span class="header-title">添加</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="closeWindow('openAdd', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <el-form ref="ruleFormRef" :model="ruleForm" label-width="90px">
        <el-row>
          <el-col :span="24">
            <el-form-item label="请假类型" prop="qjlxid" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
              <el-select v-model="ruleForm.qjlxid" clearable filterable>
                <el-option v-for="(item, index) in jzgqjlxData" :key="index" :label="item.bt" :value="item.id" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="请假时间" prop="qjkssj" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
              <el-date-picker v-model="qjsj" type="datetimerange" range-separator="-" start-placeholder="开始时间" end-placeholder="结束时间" value-format="YYYY-MM-DD HH:mm" format="YYYY-MM-DD HH:mm" @change="qjsjChange"/>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="请假天数" prop="qjts" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
              <el-input-number v-model="ruleForm.qjts" :min="0" :precision="1" />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="请假原因" prop="qjyy">
              <el-input v-model="ruleForm.qjyy" :rows="6" type="textarea" resize="none"/>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <template #footer>
        <div class="dialog-footer">
          <div></div>
          <div class="footer_but">
            <el-button type="primary" @click="submit()">保存</el-button>
            <el-button type="info" @click="closeWindow('openAdd', emits, false)">关闭</el-button>
          </div>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import { defineProps, defineEmits, ref, watch, unref } from 'vue'
import { submitForm, closeWindow } from '@/api/common.js'
import { loadZiDianSelect } from '@/api/queryZiDian.js'

const props = defineProps({ openAdd: { type: Boolean, required: true } })
const emits = defineEmits(['update:openAdd', 'ReturnData'])
const ruleFormRef = ref(null)
const ruleForm = ref({})
const qjsj = ref([]) // 请假时间
const jzgqjlxData = ref() // 教职工请假类型
// 拆分请假时间
const qjsjChange = () => {
  ruleForm.value.qjkssj = qjsj.value[0]
  ruleForm.value.qjjssj = qjsj.value[1]
}

watch(
  () => props.openAdd,
  () => {
    if (props.openAdd) {
      ruleForm.value.jzgid = JSON.parse(sessionStorage.getItem('USER_INFO')).id
      loadZiDianSelect('教职工请假类型', jzgqjlxData, 'sx', 'asc')
    }
  },
  { deep: true, immediate: true }
)

// 提交
const submit = async () => {
  submitForm({
    url: '/api/v2/jiaowu/jiaozhigongqingjiajilu',
    ruleFormRef: unref(ruleFormRef),
    ruleForm: ruleForm.value,
    callback: function (res) {
      closeWindow('openAdd', emits, true)
    }
  })
}
</script>
